/**
 * CircularProgress — indeterminate circular spinner.
 *
 * A rotating arc (like IndeterminateBar but circular): mostly solid primary
 * color with faded/toned ends. No background track.
 *
 * Used in login input, message alerts, and other inline loading states.
 */

import { cn } from "@/shared/utils/general/cn"

interface CircularProgressProps {
  className?: string
}

export function CircularProgress({ className }: CircularProgressProps) {
  return (
    <svg
      className={cn("animate-spin text-primary", className)}
      viewBox="0 0 44 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        {/* Conic gradient: fades at start/end, solid primary in the middle */}
        <linearGradient id="cp-grad-a" gradientUnits="userSpaceOnUse" x1="22" y1="2" x2="42" y2="22">
          <stop offset="0%" stopColor="currentColor" stopOpacity="0" />
          <stop offset="100%" stopColor="currentColor" stopOpacity="1" />
        </linearGradient>
        <linearGradient id="cp-grad-b" gradientUnits="userSpaceOnUse" x1="42" y1="22" x2="22" y2="42">
          <stop offset="0%" stopColor="currentColor" stopOpacity="1" />
          <stop offset="100%" stopColor="currentColor" stopOpacity="1" />
        </linearGradient>
        <linearGradient id="cp-grad-c" gradientUnits="userSpaceOnUse" x1="22" y1="42" x2="2" y2="22">
          <stop offset="0%" stopColor="currentColor" stopOpacity="1" />
          <stop offset="100%" stopColor="currentColor" stopOpacity="0" />
        </linearGradient>
      </defs>
      {/* Three arc segments: fade-in → solid → fade-out (270° total) */}
      {/* Segment 1: top to right (fade in) */}
      <path
        d="M22 4 A18 18 0 0 1 40 22"
        stroke="url(#cp-grad-a)"
        strokeWidth="3"
        strokeLinecap="round"
        fill="none"
      />
      {/* Segment 2: right to bottom (solid) */}
      <path
        d="M40 22 A18 18 0 0 1 22 40"
        stroke="url(#cp-grad-b)"
        strokeWidth="3"
        fill="none"
      />
      {/* Segment 3: bottom to left (fade out) */}
      <path
        d="M22 40 A18 18 0 0 1 4 22"
        stroke="url(#cp-grad-c)"
        strokeWidth="3"
        strokeLinecap="round"
        fill="none"
      />
    </svg>
  )
}
